module.exports = __webpack_public_path__ + "img/storyboard_that_splash.41f1ecb7.jpg";